// utils
import request from '../utils/Request'

class MainService {

  async listExames(params, protocol, hashPassword) {
    const url = (protocol && hashPassword)
      ? `${process.env.REACT_APP_API_MAIN}/exame/paciente-laudos/${protocol}/${hashPassword}`
      : `${process.env.REACT_APP_API_MAIN}/exame/paciente-laudos`
    const result = await request.get(url, params)
    return result
  }

  /**
   * Obtem iformações do exame e seus respectivos questionários
   *
   * @param {*} id
   * @param {*} context
   */
  async getExamePsico(id, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/exame/${id}/questionarios-psico?context=${context}`
    const result = await request.get(url)
    return result
  }

  /**
   * Confirma a data de nascimento do paciente para autorizar inpressão de laudo e visualização de anexos do exame.
   */
  async confirmPacienteBirth(data, protocol, hashPassword) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/confirm-birth/${protocol}/${hashPassword}`
    const result = await request.post(url, {}, JSON.stringify({data}))
    return result
  }

  async getQuizQuestions(idQuiz, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/questionario/${idQuiz}/responder?context=${context}`
    const result = await request.get(url)
    return result
  }

  async putSaveAnswers(idQuiz, data, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/questionario/${idQuiz}/responder?context=${context}`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

  async putSaveAnswersPsico(idExame, data, type, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/exame/${idExame}/questionarios-psico/${type}?context=${context}`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  async getAddressByCep(cep) {
    const options = {
      timeout: {
        response: 5 * 1000,  // Wait 5s for the server to start sending,
        deadline: 5 * 1000, // but allow 5s for the file to finish loading.
      },
    }
    const url = `${process.env.REACT_APP_API_MAIN}/endereco/cep/${cep}`
    const result = await request.get(url, {}, options)
    return result
  }

  async listCountries() {
    const url = `${process.env.REACT_APP_API_MAIN}/pais`
    const result = await request.get(url)
    return result
  }

  async listStates(params) {
    const url = `${process.env.REACT_APP_API_MAIN}/endereco/estado-ibge`
    const result = await request.get(url, params)
    return result
  }

  async listCities(params) {
    const url = `${process.env.REACT_APP_API_MAIN}/endereco/cidade-ibge`
    const result = await request.get(url, params)
    return result
  }

  async putDataToNfse(data) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/dados-nfse`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  async putPersonalData(data) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/dados-pessoais`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  async postUserPacienteAddress(data) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/user/address`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

  async deleteUserPacienteAddress(id) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/user/address/${id}`
    const result = await request.delete(url)
    return result
  }

  async getUserPacienteAddress() {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/user/adresses`
    const result = await request.get(url)
    return result
  }

  async getPrescricaoRenovacaoPrecosPrazos(idPacienteEndereco) {
    const url = `${process.env.REACT_APP_API_MAIN}/prescricao-renovacao/endereco/${idPacienteEndereco}/precos-prazos`
    const result = await request.get(url)
    return result
  }

  /**
   * Obtem registro de renovação de receita (prescrição)
   *
   * @param {*} id
   * @param {*} context
   */
  async getPrescricaoRenovacao(id, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/prescricao-renovacao/${id}?context=${context}`
    const result = await request.get(url)
    return result
  }

  /**
   * Cria solicitação de renovação de receita (prescrição).
   */
  async postPrescricaoRenovacao(data, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/prescricao-renovacao?context=${context}`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

  /**
   * Altera solicitação de renovação de receita (prescrição) ajuste quando rejeitada.
   */
   async putPrescricaoRenovacao(data, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/prescricao-renovacao/${data.id}?context=${context}`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  /**
   * Lista dependnetes do paciente
   *
   * @param {*} id
   * @param {*} context
   */
  async getDependents(context, params = {}) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/dependentes?context=${context}`
    const result = await request.get(url, params)
    return result
  }

  /**
   * Obtem dependnete por ID
   *
   * @param {*} id
   * @param {*} context
   */
  async getDependent(id, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/dependentes/${id}?context=${context}`
    const result = await request.get(url)
    return result
  }

  /**
   * Obtem dependnete por ID
   *
   * @param {*} id
   * @param {*} context
   */
  async postDependent(data, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/dependentes?context=${context}`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

  /**
   * Obtem dependnete por ID
   *
   * @param {*} id
   * @param {*} context
   */
  async putDependent(data, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/dependentes/${data.id}?context=${context}`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  /**
   * Obtem assinatura do paciente.
   *
   * @param {*} id
   * @param {*} context
   */
   async getPatientSignature(id, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/${id}/signature/${context}`
    const result = await request.get(url)
    return result
  }

  /**
   * Persiste assinatura do paciente.
   *
   * @param {*} id
   * @param {*} context
   */
   async putPatientSignature(data, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/${data.id}/signature/${context}`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  /**
   * Envia mensagem de suporte 'admin' ou 'médico'.
   *
   * @param {*} id
   * @param {*} context
   */
  async postMensagemSuporte(data) {
    const url = `${process.env.REACT_APP_API_MAIN}/mensagem`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

  /**
   * Carrega mensagens de uma determinada entidade por id, um dos IDs é obrigatório.
   *
   * @param {Number} idTeleconsulta ID da teleconsulta caso seja referente a uma.
   * @param {Number} idPrescricao ID do prontuario_prescricao_renovacao coso seja referente a um.
   */
   async getMensagensSuporte(idTeleconsulta, idPrescricao) {
    const url = `${process.env.REACT_APP_API_MAIN}/mensagem`
    const result = await request.get(url, {id_prescricao_renovacao: idPrescricao, id_teleconsulta: idTeleconsulta})
    return result
  }

}

export default new MainService()
